(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7839],{

/***/ "./node_modules/@chakra-ui/tag/dist/index.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AD": function() { return /* binding */ TagLeftIcon; },
/* harmony export */   "Sn": function() { return /* binding */ TagLabel; },
/* harmony export */   "Vp": function() { return /* binding */ Tag; }
/* harmony export */ });
/* unused harmony exports TagCloseButton, TagRightIcon, useTagStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/@chakra-ui/react-context/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/styled-system/dist/index.esm.js");
// ../../../react-shim.js


// src/tag.tsx



var [TagStylesProvider, useTagStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `TagStylesContext`,
  errorMessage: `useTagStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Tag />" `
});
var Tag = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Tag", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const containerStyles = {
    display: "inline-flex",
    verticalAlign: "top",
    alignItems: "center",
    maxWidth: "100%",
    ...styles.container
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TagStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    ...ownProps,
    __css: containerStyles
  }));
});
Tag.displayName = "Tag";
var TagLabel = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const styles = useTagStyles();
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    noOfLines: 1,
    ...props,
    __css: styles.label
  });
});
TagLabel.displayName = "TagLabel";
var TagLeftIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
  ref,
  verticalAlign: "top",
  marginEnd: "0.5rem",
  ...props
}));
TagLeftIcon.displayName = "TagLeftIcon";
var TagRightIcon = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
  ref,
  verticalAlign: "top",
  marginStart: "0.5rem",
  ...props
}));
TagRightIcon.displayName = "TagRightIcon";
var TagCloseIcon = (props) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_icon__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
  verticalAlign: "inherit",
  viewBox: "0 0 512 512",
  ...props
}, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
}));
TagCloseIcon.displayName = "TagCloseIcon";
var TagCloseButton = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)((props, ref) => {
  const { isDisabled, children, ...rest } = props;
  const styles = useTagStyles();
  const btnStyles = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    outline: "0",
    ...styles.closeButton
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.button */ .m$.button, {
    ref,
    "aria-label": "close",
    ...rest,
    type: "button",
    disabled: isDisabled,
    __css: btnStyles
  }, children || /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(TagCloseIcon, null));
});
TagCloseButton.displayName = "TagCloseButton";



/***/ }),

/***/ "./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Factivity%2Findex.tsx&page=%2Factivity!":
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity",
      function () {
        return __webpack_require__("./src/pages/activity/index.tsx");
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ "./src/components/Activity/ActivityCard/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Activity_ActivityCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 5 modules
var index_esm = __webpack_require__("./node_modules/@chakra-ui/system/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__("./node_modules/next/link.js");
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardTop.tsx




const getCategoryAbbr = (id)=>{
    switch(id){
        case "defi":
            return "Defi";
        case "people":
            return "PIC";
        case "dapps":
            return "Dapps";
        case "cryptocurrencies":
            return "Crypto";
        case "daos":
            return "DAOs";
        case "exchanges":
            return "Exch";
        case "nfts":
            return "Nfts";
        case "organizations":
            return "Org";
    }
};
const ActivityCardTop = (props)=>{
    const { title , activity , category , link  } = props;
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
        justifyContent: "space-between",
        wrap: "wrap",
        alignItems: "center",
        mb: {
            base: 0,
            md: 2
        },
        width: "100%",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                flex: "1",
                sx: {
                    "@media screen and (max-width: 450px)": {
                        maxWidth: "200px"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Heading */.X6, {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        letterSpacing: "wide",
                        fontSize: {
                            base: 16,
                            md: "18px"
                        },
                        onClick: ()=>router.push(link),
                        tabIndex: 0,
                        role: "link",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        fontSize: "xs",
                        color: "brandLinkColor",
                        fontWeight: "medium",
                        children: activity
                    })
                ]
            }),
            category && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                as: (link_default()),
                href: "/categories/".concat(category === null || category === void 0 ? void 0 : category.id),
                color: "brandLinkColor",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: {
                    base: "14px",
                    lg: "16px"
                },
                display: {
                    base: "none",
                    md: "unset"
                },
                children: (category === null || category === void 0 ? void 0 : category.title) ? category === null || category === void 0 ? void 0 : category.title : category === null || category === void 0 ? void 0 : category.id
            }),
            category && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                as: (link_default()),
                href: "/categories/".concat(category === null || category === void 0 ? void 0 : category.id),
                color: "brandLinkColor",
                fontWeight: "bold",
                cursor: "pointer",
                fontSize: {
                    base: "14px",
                    lg: "16px"
                },
                display: {
                    base: "block",
                    md: "none"
                },
                children: (category === null || category === void 0 ? void 0 : category.title) ? getCategoryAbbr(category === null || category === void 0 ? void 0 : category.id) : category === null || category === void 0 ? void 0 : category.id
            })
        ]
    });
};
/* harmony default export */ var ActivityCard_ActivityCardTop = (ActivityCardTop);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/tag/dist/index.esm.js
var tag_dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/tag/dist/index.esm.js");
// EXTERNAL MODULE: ./src/components/Elements/LinkElements/LinkWrapper.tsx
var LinkWrapper = __webpack_require__("./src/components/Elements/LinkElements/LinkWrapper.tsx");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardTags.tsx



const ActivityCardTags = (param)=>{
    let { tags  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Wrap */.Eq, {
        spacing: 2,
        children: tags === null || tags === void 0 ? void 0 : tags.map((tag, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* LinkWrapper */.g, {
                href: "/tags/".concat(tag.id),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tag_dist_index_esm/* Tag */.Vp, {
                    as: "a",
                    size: "sm",
                    whiteSpace: "nowrap",
                    minWidth: "0",
                    sx: {
                        p: {
                            base: {
                                padding: 0
                            }
                        }
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        px: 4,
                        children: tag.id
                    })
                }, index)
            }, index))
    });
};
/* harmony default export */ var ActivityCard_ActivityCardTags = (ActivityCardTags);

;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardBody.tsx




const ActivityCardBody = (props)=>{
    const { isNotifSubCard , tags , summary  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                mt: "1",
                noOfLines: {
                    base: 3,
                    md: 2
                },
                textOverflow: "ellipsis",
                overflow: "hidden",
                width: "100%",
                fontSize: {
                    base: "14px",
                    md: isNotifSubCard ? "14px" : "16px"
                },
                children: summary
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
                display: {
                    base: "block",
                    md: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardTags, {
                    tags: tags
                })
            })
        ]
    });
};
/* harmony default export */ var ActivityCard_ActivityCardBody = (ActivityCardBody);

// EXTERNAL MODULE: ./src/utils/DataTransform/getFormattedDate.ts
var getFormattedDate = __webpack_require__("./src/utils/DataTransform/getFormattedDate.ts");
// EXTERNAL MODULE: ./src/utils/DataTransform/getUsername.ts
var getUsername = __webpack_require__("./src/utils/DataTransform/getUsername.ts");
// EXTERNAL MODULE: ./src/components/Elements/Avatar/DisplayAvatar.tsx
var DisplayAvatar = __webpack_require__("./src/components/Elements/Avatar/DisplayAvatar.tsx");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardBottom.tsx






const ActivityCardBottom = (props)=>{
    var ref, ref1;
    const { editor , isNotifSubCard , lastModTimeStamp , activity , tags  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
        w: "full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* HStack */.Ug, {
                flex: "1",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DisplayAvatar/* default */.Z, {
                        address: editor.id,
                        avatarIPFS: (ref = editor.profile) === null || ref === void 0 ? void 0 : ref.avatar,
                        size: isNotifSubCard ? 15 : 20,
                        alt: (ref1 = editor.profile) === null || ref1 === void 0 ? void 0 : ref1.username
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                        fontSize: {
                            base: isNotifSubCard ? "12px" : "12px",
                            md: isNotifSubCard ? "12px" : "14px"
                        },
                        color: "linkColor",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
                            href: "/account/".concat(editor.id),
                            color: "brandLinkColor",
                            fontWeight: "bold",
                            children: (0,getUsername/* getUsername */.M)(editor)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
                        display: {
                            base: "none",
                            md: "block"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardTags, {
                            tags: tags
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.xv, {
                mt: "3px",
                fontSize: {
                    base: isNotifSubCard ? "12px" : "12px",
                    md: isNotifSubCard ? "12px" : "14px"
                },
                opacity: 0.6,
                whiteSpace: "nowrap",
                children: "".concat(activity === "Edited" ? activity : "Created", " ").concat((0,getFormattedDate/* getReadableDate */._)(lastModTimeStamp !== null && lastModTimeStamp !== void 0 ? lastModTimeStamp : ""), " ago")
            })
        ]
    });
};
/* harmony default export */ var ActivityCard_ActivityCardBottom = (ActivityCardBottom);

// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiImageUrl.ts
var getWikiImageUrl = __webpack_require__("./src/utils/WikiUtils/getWikiImageUrl.ts");
// EXTERNAL MODULE: ./src/components/Elements/Image/Image.tsx
var Image = __webpack_require__("./src/components/Elements/Image/Image.tsx");
;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/ActivityCardImage.tsx





const ActivityCardImage = (props)=>{
    const { title , link , isNotifSubCard , wikiImgObj  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Link */.rU, {
        href: link,
        mr: 4,
        display: {
            base: "none",
            md: "block"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* AspectRatio */.oM, {
            ratio: Constants/* WIKI_IMAGE_ASPECT_RATIO */.ag,
            w: {
                base: isNotifSubCard ? "80px" : "100px",
                md: "140px",
                lg: "156px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* Image */.E, {
                boxSize: "100%",
                cursor: "pointer",
                flexShrink: 0,
                src: (0,getWikiImageUrl/* getWikiImageUrl */.A)(wikiImgObj),
                borderRadius: "lg",
                overflow: "hidden",
                alt: title,
                imgBoxSize: Constants/* IMAGE_BOX_SIZE */.xh
            })
        })
    });
};
/* harmony default export */ var ActivityCard_ActivityCardImage = (ActivityCardImage);

;// CONCATENATED MODULE: ./src/components/Activity/ActivityCard/index.tsx







const ActivityCard = (props)=>{
    const { isNotifSubCard =false , title , summary , editor , categories , tags , lastModTimeStamp , activityId , wikiImgObj , wikiId , type , ipfs  } = props;
    const link = ipfs !== undefined ? "/revision/".concat(activityId) : "/wiki/".concat(wikiId);
    const activity = type === "CREATED" ? "New" : "Edited";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* chakra.div */.m$.div, {
        bg: "cardBg",
        py: 3,
        px: 2,
        borderRadius: 8,
        borderColor: "borderColor",
        borderWidth: "0.5px",
        borderStyle: "solid",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* Flex */.kC, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardImage, {
                    title: title,
                    link: link,
                    isNotifSubCard: isNotifSubCard,
                    wikiImgObj: wikiImgObj
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist_index_esm/* VStack */.gC, {
                    spacing: 2,
                    alignItems: "flex-start",
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardTop, {
                            title: title,
                            link: link,
                            activity: activity,
                            category: categories === null || categories === void 0 ? void 0 : categories[0]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardBody, {
                            link: link,
                            summary: summary,
                            isNotifSubCard: isNotifSubCard,
                            tags: tags
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard_ActivityCardBottom, {
                            activity: activity,
                            editor: editor,
                            lastModTimeStamp: lastModTimeStamp,
                            isNotifSubCard: isNotifSubCard,
                            tags: tags
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Activity_ActivityCard = (ActivityCard);


/***/ }),

/***/ "./src/components/Elements/Avatar/DisplayAvatar.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/boring-avatars/build/index.js");
/* harmony import */ var boring_avatars__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(boring_avatars__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./node_modules/@chakra-ui/avatar/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./node_modules/@chakra-ui/icon/dist/index.esm.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var _data_AvatarData__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/data/AvatarData.ts");
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./node_modules/react-icons/ri/index.esm.js");
/* harmony import */ var _hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/hooks/useENSData.ts");
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/config/index.ts");
/* harmony import */ var _services_profile_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/services/profile/utils.ts");
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/components/Elements/Image/Image.tsx");










const DisplayAvatar = (param)=>{
    let { address , svgProps , avatarIPFS , wrapperProps , size =26 , alt , ...rest } = param;
    const [avatar] = (0,_hooks_useENSData__WEBPACK_IMPORTED_MODULE_3__/* .useENSData */ .L)(address);
    const { avatar: fetchedAvatarIPFS , setAccount  } = (0,_services_profile_utils__WEBPACK_IMPORTED_MODULE_5__/* .useUserProfileData */ .Cf)(_services_profile_utils__WEBPACK_IMPORTED_MODULE_5__/* .UserProfileFetchOptions.ONLY_AVATAR */ .Ky.ONLY_AVATAR);
    let content = null;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (address && !avatarIPFS) {
            setAccount(address);
        }
    }, [
        address,
        avatarIPFS,
        setAccount
    ]);
    if (avatarIPFS || fetchedAvatarIPFS) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
            imgBoxSize: size,
            src: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(avatarIPFS || fetchedAvatarIPFS),
            borderRadius: "full",
            ...rest,
            alt: alt || "Avatar"
        });
    } else if (avatar) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Avatar */ .qE, {
            boxSize: "".concat(size, "px"),
            src: avatar,
            name: alt,
            ...rest
        });
    } else if (address && !avatar) {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((boring_avatars__WEBPACK_IMPORTED_MODULE_2___default()), {
            size: size,
            variant: "pixel",
            name: address,
            colors: _data_AvatarData__WEBPACK_IMPORTED_MODULE_8__/* .AvatarColorArray */ .M
        });
    } else {
        content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .JO, {
            cursor: "pointer",
            fontSize: size,
            color: "gray.600",
            _dark: {
                color: "gray.200"
            },
            fontWeight: 600,
            as: react_icons_ri__WEBPACK_IMPORTED_MODULE_10__/* .RiUserLine */ .s60,
            title: alt
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .Center */ .M5, {
        ...wrapperProps,
        sx: {
            svg: {
                ...svgProps
            }
        },
        borderRadius: "full",
        children: content
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (DisplayAvatar);


/***/ }),

/***/ "./src/components/Elements/Image/Image.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* unused harmony export cfLoader */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/react/jsx-runtime.js");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/next/image.js");
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);




const BASE_URL = "https://iq.wiki";
const cfLoader = (param)=>{
    let { src , width , quality  } = param;
    const params = [
        "width=".concat(width)
    ];
    if (quality) params.push("quality=".concat(quality));
    const paramsString = params.join(",");
    return "".concat(BASE_URL, "/cdn-cgi/image/").concat(paramsString, "/").concat(normalizeSrc(src));
};
const normalizeSrc = (src)=>{
    return src.startsWith("/") ? src.slice(1) : src;
};
const Image = (param)=>/*#__PURE__*/ {
    let { src , alt , priority , placeholder , blurDataURL , hideOnError , sizes , objectFit ="cover" , imgBoxSize , imgW , imgH , ...rest } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, {
        h: "".concat(imgBoxSize || imgH, "px"),
        w: "".concat(imgBoxSize || imgW, "px"),
        ...rest,
        overflow: "hidden",
        position: "relative",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
            quality: 95,
            style: {
                objectFit,
                objectPosition: "top",
                width: "100%",
                height: "100%"
            },
            loader: typeof src === "string" && src.startsWith("http") ? cfLoader : undefined,
            fill: !(imgW && imgH) || !imgBoxSize,
            src: src,
            alt: alt,
            onError: (e)=>{
                if (hideOnError) {
                    e.currentTarget.style.visibility = "hidden";
                }
            },
            priority: priority,
            sizes: sizes,
            placeholder: placeholder,
            blurDataURL: blurDataURL,
            loading: priority ? "eager" : "lazy",
            width: imgBoxSize || imgW,
            height: imgBoxSize || imgH
        })
    });
};


/***/ }),

/***/ "./src/data/AvatarData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ AvatarColorArray; }
/* harmony export */ });
const AvatarColorArray = [
    "#92A1C6",
    "#146A7C",
    "#F0AB3D",
    "#C271B4",
    "#C20D90"
];


/***/ }),

/***/ "./src/data/Constants.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BJ": function() { return /* binding */ ITEM_PER_PAGE; },
/* harmony export */   "L": function() { return /* binding */ WIKI_METADATA_VALUE_LIMIT; },
/* harmony export */   "Nf": function() { return /* binding */ FETCH_DELAY_TIME; },
/* harmony export */   "Vl": function() { return /* binding */ CATEGORY_DESCRIPTION_WORD_LIMIT; },
/* harmony export */   "a": function() { return /* binding */ WIKI_SUMMARY_LIMIT; },
/* harmony export */   "ag": function() { return /* binding */ WIKI_IMAGE_ASPECT_RATIO; },
/* harmony export */   "ft": function() { return /* binding */ MEDIA_POST_DEFAULT_ID; },
/* harmony export */   "hj": function() { return /* binding */ WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL; },
/* harmony export */   "xh": function() { return /* binding */ IMAGE_BOX_SIZE; }
/* harmony export */ });
/* unused harmony exports WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS, GPT3_COST_PER_1K_TOKENS, GPT3_MAX_TRIES */
const ITEM_PER_PAGE = 12;
const FETCH_DELAY_TIME = 3000;
const CATEGORY_DESCRIPTION_WORD_LIMIT = 200;
const MEDIA_POST_DEFAULT_ID = "UPLOADING_ID";
const WIKI_IMAGE_ASPECT_RATIO = 4 / 3;
const WIKI_METADATA_VALUE_LIMIT = 255;
const WIKI_SUMMARY_LIMIT = 255;
const WIKI_SUMMARY_GEN_RATE_LIMIT_INTERVAL = 10 * 60 * 1000 // 10 Mins
;
const WIKI_SUMMARY_GEN_RATE_LIMIT_MAX_REQUESTS = 5;
const GPT3_COST_PER_1K_TOKENS = 0.02;
const GPT3_MAX_TRIES = 3;
const IMAGE_BOX_SIZE = 150;


/***/ }),

/***/ "./src/hooks/useENSData.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ useENSData; }
/* harmony export */ });
/* harmony import */ var _services_ens__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/services/ens/index.ts");
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/react/index.js");



const useENSData = (address, skip)=>{
    const [avatar, setAvatar] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const [displayName, setDisplayName] = react__WEBPACK_IMPORTED_MODULE_2__.useState("");
    const [loading, setLoading] = react__WEBPACK_IMPORTED_MODULE_2__.useState(false);
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(()=>{
        if (!address || skip) return;
        const fetchEnsData = async ()=>{
            setLoading(true);
            const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_1__/* .store.dispatch */ .h.dispatch(_services_ens__WEBPACK_IMPORTED_MODULE_0__/* .getEns.initiate */ .gS.initiate(address.toLowerCase()));
            if (data) {
                setAvatar(data.avatar);
                setDisplayName((p)=>data.displayName.endsWith(".eth") ? data.displayName : p);
            }
            setLoading(false);
        };
        fetchEnsData();
    }, [
        address,
        skip
    ]);
    return [
        avatar,
        displayName,
        loading
    ];
};


/***/ }),

/***/ "./src/pages/activity/index.tsx":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ activity; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__("./node_modules/react/jsx-runtime.js");
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__("./node_modules/@chakra-ui/layout/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var dist_index_esm = __webpack_require__("./node_modules/@chakra-ui/spinner/dist/index.esm.js");
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js + 1 modules
var react_infinite_scroll_hook_esm = __webpack_require__("./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js");
// EXTERNAL MODULE: ./src/components/Activity/ActivityCard/index.tsx + 5 modules
var ActivityCard = __webpack_require__("./src/components/Activity/ActivityCard/index.tsx");
// EXTERNAL MODULE: ./src/services/activities/index.ts + 1 modules
var services_activities = __webpack_require__("./src/services/activities/index.ts");
// EXTERNAL MODULE: ./src/store/store.ts + 9 modules
var store = __webpack_require__("./src/store/store.ts");
// EXTERNAL MODULE: ./src/data/Constants.ts
var Constants = __webpack_require__("./src/data/Constants.ts");
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__("./node_modules/react-i18next/dist/es/useTranslation.js");
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__("./src/utils/googleAnalytics.ts");
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__("./node_modules/next/router.js");
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__("./node_modules/next-seo/lib/next-seo.module.js");
;// CONCATENATED MODULE: ./src/components/SEO/Activity.tsx



const ActivityHeader = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
        title: "Recent Activities",
        description: "Check out recent wiki activities",
        canonical: "https://iq.wiki/static/activity",
        openGraph: {
            title: "Activities",
            description: "Check out recent wiki activities"
        },
        twitter: {
            cardType: "summary_large_image",
            handle: "@IQWIKI",
            site: "IQWiki"
        }
    });
/* harmony default export */ var Activity = (ActivityHeader);

// EXTERNAL MODULE: ./src/utils/WikiUtils/getWikiSummary.ts
var getWikiSummary = __webpack_require__("./src/utils/WikiUtils/getWikiSummary.ts");
;// CONCATENATED MODULE: ./src/pages/activity/index.tsx













const activity_Activity = (param)=>{
    let { activities  } = param;
    const [LatestActivityData, setLatestActivityData] = (0,react.useState)(activities);
    const [hasMore, setHasMore] = (0,react.useState)(true);
    const [loading, setLoading] = (0,react.useState)(false);
    const [offset, setOffset] = (0,react.useState)(0);
    const router = (0,next_router.useRouter)();
    const getUpdatedActivities = (data)=>{
        const position = {};
        data.map((item)=>{
            if (!position[item.wikiId]) {
                position[item.wikiId] = 1;
                item.ipfs = undefined;
            }
            return null;
        });
        return data;
    };
    (0,react.useEffect)(()=>{
        getUpdatedActivities(LatestActivityData);
    }, [
        LatestActivityData
    ]);
    const fetchMoreActivities = ()=>{
        const updatedOffset = offset + Constants/* ITEM_PER_PAGE */.BJ;
        setTimeout(()=>{
            const fetchNewActivities = async ()=>{
                var ref;
                const result = await store/* store.dispatch */.h.dispatch(services_activities/* getLatestActivities.initiate */.vz.initiate({
                    limit: Constants/* ITEM_PER_PAGE */.BJ,
                    offset: updatedOffset
                }));
                if (result.data && ((ref = result.data) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                    (0,googleAnalytics/* pageView */.t)("".concat(router.asPath, "?page=").concat(updatedOffset));
                    const data = result.data.map((item)=>({
                            content: item.content,
                            datetime: item.datetime,
                            id: item.id,
                            ipfs: item.ipfs,
                            type: item.type,
                            wikiId: item.wikiId
                        }));
                    const updatedActivities = getUpdatedActivities([
                        ...LatestActivityData,
                        ...data
                    ]);
                    setLatestActivityData(updatedActivities);
                    setOffset(updatedOffset);
                } else {
                    setHasMore(false);
                    setLoading(false);
                }
            };
            fetchNewActivities();
        }, Constants/* FETCH_DELAY_TIME */.Nf);
    };
    const [sentryRef] = (0,react_infinite_scroll_hook_esm/* default */.Z)({
        loading,
        hasNextPage: hasMore,
        onLoadMore: fetchMoreActivities,
        rootMargin: "0px 0px 400px 0px"
    });
    const renderActivityCard = (activity)=>{
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(ActivityCard/* default */.Z, {
            title: activity.content[0].title,
            summary: (0,getWikiSummary/* getWikiSummary */.L)(activity === null || activity === void 0 ? void 0 : activity.content[0]),
            editor: activity.content[0].user,
            lastModTimeStamp: activity.datetime,
            activityId: activity.id,
            type: activity.type,
            wikiId: activity.wikiId,
            ipfs: activity.ipfs,
            wikiImgObj: activity.content[0].images,
            categories: activity.content[0].categories,
            tags: activity.content[0].tags
        }, activity.id);
    };
    const { t  } = (0,useTranslation/* useTranslation */.$)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Activity, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                bgColor: "pageBg",
                my: -8,
                py: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    w: "min(90%, 1100px)",
                    mx: "auto",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            my: {
                                base: 8,
                                md: 12
                            },
                            as: "h1",
                            size: {
                                base: "lg",
                                md: "2xl"
                            },
                            letterSpacing: "wide",
                            children: "Recent Activity"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                        flexDirection: "column",
                                        overflow: "hidden",
                                        gap: 4,
                                        children: LatestActivityData === null || LatestActivityData === void 0 ? void 0 : LatestActivityData.map((activity)=>renderActivityCard(activity))
                                    })
                                }),
                                loading || hasMore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    ref: sentryRef,
                                    my: "10",
                                    w: "full",
                                    h: "16",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Spinner */.$, {
                                        size: "xl"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Center */.M5, {
                                    my: "10",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                                        fontWeight: "semibold",
                                        children: t("seenItAll")
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var activity = (activity_Activity);


/***/ }),

/***/ "./src/services/profile/utils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ useUserProfileData; },
/* harmony export */   "Ky": function() { return /* binding */ UserProfileFetchOptions; },
/* harmony export */   "oN": function() { return /* binding */ isUserNameTaken; }
/* harmony export */ });
/* harmony import */ var _store_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/store/store.ts");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/react/index.js");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/services/profile/index.tsx");



var UserProfileFetchOptions;
(function(UserProfileFetchOptions) {
    UserProfileFetchOptions[UserProfileFetchOptions["WITH_ALL_SETTINGS"] = 0] = "WITH_ALL_SETTINGS";
    UserProfileFetchOptions[UserProfileFetchOptions["ONLY_EMAIL"] = 1] = "ONLY_EMAIL";
    UserProfileFetchOptions[UserProfileFetchOptions["ONLY_AVATAR"] = 2] = "ONLY_AVATAR";
    UserProfileFetchOptions[UserProfileFetchOptions["USER_PROFILE"] = 3] = "USER_PROFILE";
})(UserProfileFetchOptions || (UserProfileFetchOptions = {}));
const useUserProfileData = (options, address)=>{
    const [profileData, setProfileData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [avatar, setAvatar] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)();
    const [account, setAccount] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(address || "");
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (!account) return;
        const fetchSettings = async ()=>{
            try {
                if (options === UserProfileFetchOptions.WITH_ALL_SETTINGS) {
                    const { data: fetchedProfileData  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserSettings.initiate */ .nS.initiate(account));
                    setProfileData(fetchedProfileData);
                } else if (options === UserProfileFetchOptions.ONLY_AVATAR) {
                    const { data: fetchedUserProfileAvatar  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserAvatar.initiate */ .Dm.initiate(account));
                    setAvatar(fetchedUserProfileAvatar);
                } else if (options === UserProfileFetchOptions.ONLY_EMAIL) {
                    const { data: fetchedProfileData1  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserEmail.initiate */ .gV.initiate(account));
                    setProfileData(fetchedProfileData1);
                } else if (options === UserProfileFetchOptions.USER_PROFILE) {
                    const { data: fetchedProfileData2  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUserProfile.initiate */ .et.initiate(account));
                    setProfileData(fetchedProfileData2);
                }
                setLoading(false);
            } catch (_err) {
                setLoading(false);
            }
        };
        fetchSettings();
    }, [
        account,
        options
    ]);
    return {
        setAccount,
        profileData,
        loading,
        avatar
    };
};
const isUserNameTaken = async (username)=>{
    const { data  } = await _store_store__WEBPACK_IMPORTED_MODULE_0__/* .store.dispatch */ .h.dispatch(___WEBPACK_IMPORTED_MODULE_2__/* .getUsernameTaken.initiate */ .l4.initiate(username));
    return data;
};


/***/ }),

/***/ "./src/utils/DataTransform/getFormattedDate.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getReadableDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/date-fns/esm/formatDistanceToNowStrict/index.js");

const getReadableDate = (dateToFormat)=>{
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(dateToFormat), {
        addSuffix: false
    });
};


/***/ }),

/***/ "./src/utils/DataTransform/getUsername.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ getUsername; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

const getUsername = (user, ensDomain)=>{
    var ref;
    if (!user) {
        return "Unknown";
    }
    if ((ref = user.profile) === null || ref === void 0 ? void 0 : ref.username) {
        return user.profile.username;
    }
    if (ensDomain) {
        return ensDomain;
    }
    return user.id ? (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenAccount */ .p0)(user.id) : "Unknown";
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiImageUrl.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getWikiImageUrl; }
/* harmony export */ });
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/config/index.ts");

const getWikiImageUrl = (imageObj)=>{
    var ref;
    return "".concat(_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].pinataBaseUrl */ .Z.pinataBaseUrl).concat(imageObj ? (ref = imageObj[0]) === null || ref === void 0 ? void 0 : ref.id : "");
};


/***/ }),

/***/ "./src/utils/WikiUtils/getWikiSummary.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ WikiSummarySize; },
/* harmony export */   "L": function() { return /* binding */ getWikiSummary; }
/* harmony export */ });
/* harmony import */ var _textUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/utils/textUtils.ts");

var WikiSummarySize;
(function(WikiSummarySize) {
    WikiSummarySize[WikiSummarySize["Small"] = 65] = "Small";
    WikiSummarySize[WikiSummarySize["Medium"] = 70] = "Medium";
    WikiSummarySize[WikiSummarySize["BIG"] = 110] = "BIG";
    WikiSummarySize[WikiSummarySize["Huge"] = 160] = "Huge";
})(WikiSummarySize || (WikiSummarySize = {}));
const getWikiSummary = function(wiki) {
    let size = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : WikiSummarySize.Huge;
    if (wiki.summary) return (0,_textUtils__WEBPACK_IMPORTED_MODULE_0__/* .shortenText */ .El)(wiki.summary, size);
    return "";
};


/***/ }),

/***/ "./src/utils/textUtils.ts":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ei": function() { return /* binding */ slugifyText; },
/* harmony export */   "El": function() { return /* binding */ shortenText; },
/* harmony export */   "TY": function() { return /* binding */ lettersToNum; },
/* harmony export */   "Zw": function() { return /* binding */ isVerifiedContentLinks; },
/* harmony export */   "jv": function() { return /* binding */ isValidUrl; },
/* harmony export */   "lK": function() { return /* binding */ shortenBalance; },
/* harmony export */   "p0": function() { return /* binding */ shortenAccount; }
/* harmony export */ });
/* unused harmony export shortenMediaText */
/* harmony import */ var _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/@everipedia/iq-utils/build/module/index.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./node_modules/slugify/slugify.js");
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/humanize-plus/dist/humanize.js");
/* harmony import */ var humanize_plus__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humanize_plus__WEBPACK_IMPORTED_MODULE_2__);



const lettersToNum = (str)=>{
    let out = 0;
    const len = str.length;
    for(let pos = 0; pos < len; pos += 1){
        out += (str.charCodeAt(pos) - 64) * 26 ** (len - pos - 1);
    }
    return out;
};
const shortenAccount = function(account) {
    let firstTakeLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, secondTakeLength = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 4;
    const firstChunk = account.substring(0, firstTakeLength);
    const secondChunk = account.substring(account.length - secondTakeLength);
    return "".concat(firstChunk, "...").concat(secondChunk);
};
const shortenBalance = (balance)=>typeof balance === "number" ? humanize_plus__WEBPACK_IMPORTED_MODULE_2__.formatNumber(balance, 2) : balance;
const shortenText = (text, length)=>{
    return (text === null || text === void 0 ? void 0 : text.length) > length ? "".concat(text.substring(0, length), "...") : text;
};
const shortenMediaText = (name)=>{
    const nameArray = name.split(".");
    return nameArray[0].length > 6 ? "".concat(nameArray[0].substring(0, 6), "....").concat(nameArray[1]) : name;
};
const slugifyText = (text)=>{
    return slugify__WEBPACK_IMPORTED_MODULE_1___default()(text.toLowerCase(), {
        strict: true,
        lower: true,
        remove: /[*+~.()'"!:@]/g
    });
};
const isValidUrl = (urlString)=>{
    try {
        return Boolean(new URL(urlString));
    } catch (_e) {
        return false;
    }
};
const isVerifiedContentLinks = (content)=>{
    const markdownLinks = content.match(/\[(.*?)\]\((.*?)\)/g);
    let isValid = true;
    markdownLinks === null || markdownLinks === void 0 ? void 0 : markdownLinks.every((link)=>{
        const linkMatch = link.match(/\[(.*?)\]\((.*?)\)/);
        const text = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[1];
        const url = linkMatch === null || linkMatch === void 0 ? void 0 : linkMatch[2];
        if (text && url && _everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedLinkNames.includes */ .Kp.includes(text) && !isValidUrl(url)) {
            isValid = true;
            return true;
        }
        if (url && url.charAt(0) !== "#") {
            const validURLRecognizer = new RegExp("^https?://(www\\.)?(".concat(_everipedia_iq_utils__WEBPACK_IMPORTED_MODULE_0__/* .whiteListedDomains.join */ .xw.join("|"), ")"));
            isValid = validURLRecognizer.test(url);
            return isValid;
        }
        return true;
    });
    return isValid;
};


/***/ }),

/***/ "./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js":
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ react_infinite_scroll_hook_esm; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("./node_modules/react/index.js");
;// CONCATENATED MODULE: ./node_modules/react-intersection-observer-hook/dist/react-intersection-observer-hook.esm.js


var DEFAULT_ROOT_MARGIN = '0px';
var DEFAULT_THRESHOLD = [0]; // For more info:
// https://developers.google.com/web/updates/2016/04/intersectionobserver
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

function useIntersectionObserver(args) {
  var _args$rootMargin, _args$threshold;

  var rootMargin = (_args$rootMargin = args == null ? void 0 : args.rootMargin) != null ? _args$rootMargin : DEFAULT_ROOT_MARGIN;
  var threshold = (_args$threshold = args == null ? void 0 : args.threshold) != null ? _args$threshold : DEFAULT_THRESHOLD;
  var nodeRef = (0,react.useRef)(null);
  var rootRef = (0,react.useRef)(null);
  var observerRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(),
      entry = _useState[0],
      setEntry = _useState[1];

  var unobserve = (0,react.useCallback)(function () {
    // Disconnect the current observer (if there is one)
    var currentObserver = observerRef.current;
    currentObserver == null ? void 0 : currentObserver.disconnect();
    observerRef.current = null;
  }, []);
  var observe = (0,react.useCallback)(function () {
    var node = nodeRef.current;

    if (node) {
      var root = rootRef.current;
      var options = {
        root: root,
        rootMargin: rootMargin,
        threshold: threshold
      }; // Create a observer for current "node" with given options.

      var observer = new IntersectionObserver(function (_ref) {
        var newEntry = _ref[0];
        setEntry(newEntry);
      }, options);
      observer.observe(node);
      observerRef.current = observer;
    }
  }, [rootMargin, threshold]);
  var initializeObserver = (0,react.useCallback)(function () {
    unobserve();
    observe();
  }, [observe, unobserve]);
  var refCallback = (0,react.useCallback)(function (node) {
    nodeRef.current = node;
    initializeObserver();
  }, [initializeObserver]);
  var rootRefCallback = (0,react.useCallback)(function (rootNode) {
    rootRef.current = rootNode;
    initializeObserver();
  }, [initializeObserver]);
  (0,react.useEffect)(function () {
    // After React 18, StrictMode unmounts and mounts components to be sure
    // if they are resilient effects being mounted and destroyed multiple times.
    // This a behavior to be sure nothing breaks when off-screen components
    // can preserve their state with future React versions.
    // So in StrictMode, React unmounts the component, clean-up of this useEffect gets triggered and
    // we stop observing the node. But we need to start observing after component re-mounts with its preserved state.
    // So to handle this case, we call initializeObserver here.
    // https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-strict-mode
    initializeObserver();
    return function () {
      // We disconnect the observer on unmount to prevent memory leaks etc.
      unobserve();
    };
  }, [initializeObserver, unobserve]);
  return [refCallback, {
    entry: entry,
    rootRef: rootRefCallback
  }];
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function useTrackVisibility(args) {
  var _result$entry;

  var _useIntersectionObser = useIntersectionObserver(args),
      ref = _useIntersectionObser[0],
      result = _useIntersectionObser[1];

  var isVisible = Boolean((_result$entry = result.entry) == null ? void 0 : _result$entry.isIntersecting);

  var _useState = (0,react.useState)(isVisible),
      wasEverVisible = _useState[0],
      setWasEverVisible = _useState[1];

  (0,react.useEffect)(function () {
    if (isVisible) {
      setWasEverVisible(isVisible);
    }
  }, [isVisible]);
  return [ref, _extends({}, result, {
    isVisible: isVisible,
    wasEverVisible: wasEverVisible
  })];
}


//# sourceMappingURL=react-intersection-observer-hook.esm.js.map

;// CONCATENATED MODULE: ./node_modules/react-infinite-scroll-hook/dist/react-infinite-scroll-hook.esm.js



var DEFAULT_DELAY_IN_MS = 100;

function useInfiniteScroll(_ref) {
  var loading = _ref.loading,
      hasNextPage = _ref.hasNextPage,
      onLoadMore = _ref.onLoadMore,
      rootMargin = _ref.rootMargin,
      disabled = _ref.disabled,
      _ref$delayInMs = _ref.delayInMs,
      delayInMs = _ref$delayInMs === void 0 ? DEFAULT_DELAY_IN_MS : _ref$delayInMs;

  var _useTrackVisibility = useTrackVisibility({
    rootMargin: rootMargin
  }),
      ref = _useTrackVisibility[0],
      _useTrackVisibility$ = _useTrackVisibility[1],
      rootRef = _useTrackVisibility$.rootRef,
      isVisible = _useTrackVisibility$.isVisible;

  var shouldLoadMore = !disabled && !loading && isVisible && hasNextPage; // eslint-disable-next-line consistent-return

  (0,react.useEffect)(function () {
    if (shouldLoadMore) {
      // When we trigger 'onLoadMore' and new items are added to the list,
      // right before they become rendered on the screen, 'loading' becomes false
      // and 'isVisible' can be true for a brief time, based on the scroll position.
      // So, it triggers 'onLoadMore' just after the first one is finished.
      // We use a small delay here to prevent this kind of situations.
      // It can be configured by hook args.
      var timer = setTimeout(function () {
        onLoadMore();
      }, delayInMs);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [onLoadMore, shouldLoadMore, delayInMs]);
  return [ref, {
    rootRef: rootRef
  }];
}

/* harmony default export */ var react_infinite_scroll_hook_esm = (useInfiniteScroll);
//# sourceMappingURL=react-infinite-scroll-hook.esm.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,2192,6788,6422,9774,2888,179], function() { return __webpack_exec__("./node_modules/next/dist/build/webpack/loaders/next-client-pages-loader.js?absolutePagePath=private-next-pages%2Factivity%2Findex.tsx&page=%2Factivity!"); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);